import React from 'react';
import styled from 'styled-components';
import { P3 } from '../../Typography';

interface CounterProps {
  overLimit: boolean;
}

const Counter = styled(P3)<CounterProps>`
  color: ${(props) => (props.overLimit ? props.theme.colors.negative : props.theme.colors.body2)};
  margin: 4px 0 0;
  text-align: right;
`;

interface CharacterCounterProps {
  current: number;
  maximum: number;
}

const CharacterCounter: React.FC<CharacterCounterProps> = ({ current, maximum }) => (
  <Counter
    aria-label={`${current} of ${maximum} characters used`}
    overLimit={current > maximum}
  >{`${current} / ${maximum.toLocaleString('en-GB')}`}</Counter>
);

export default CharacterCounter;
